import {
    FaExclamationTriangle,
    FaUsers,
    FaTshirt,
    FaTasks,
    FaSmoking,
    FaMapMarkerAlt,
    FaMountain,
    FaLightbulb,
    FaTools,
    FaCalendarAlt,
    FaFireAlt
} from 'react-icons/fa';
import moment from 'moment';

// Define project name and other configuration constants
const PROJECT_NAME = 'hotel';
const PROJECT_DISPLAY_NAME = '飯店';

// Define warning types and their display properties
const WARNING_TYPES = {
    people_smoking: {
        icon: FaSmoking,
        label: '有人抽煙',
        color: 'red'
    },
    crowded: {
        icon: FaUsers,
        label: '擁擠',
        color: 'red'
    },
    hallway_clutter: {
        icon: FaTools,
        label: '走廊雜亂',
        color: 'red'
    },
    conflict_present: {
        icon: FaExclamationTriangle,
        label: '口角/打鬥',
        color: 'red'
    },
    dangerous_environment: {
        icon: FaFireAlt,
        label: '危險', // Will use the actual value from hit
        color: 'red'
    }
};

// Define info types and their display properties
const INFO_TYPES = {
    number_of_people: { icon: FaUsers, color: '#007bff' },
    clothing: { icon: FaTshirt, color: '#007bff' },
    activity: { icon: FaTasks, color: '#007bff' },
    position: { icon: FaMapMarkerAlt, color: '#007bff' },
    location: { icon: FaMountain, color: '#007bff' },
    lighting: { icon: FaLightbulb, color: '#007bff' },
    equipment_quantity: {
        icon: FaTools,
        color: '#007bff',
        condition: value => value !== 0
    },
    equipment_type: {
        icon: FaTools,
        color: '#007bff',
        condition: (_, hit) => hit.equipment_quantity !== 0
    },
    timestamp: {
        icon: FaCalendarAlt,
        color: '#007bff',
        format: value => moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
};

export { PROJECT_NAME, PROJECT_DISPLAY_NAME, WARNING_TYPES, INFO_TYPES }; 